import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { CategoriaService } from 'src/app/pages/cadastros/categoria/categoria.service';
import { EmpreiteiraService } from 'src/app/pages/cadastros/empreiteira/empreiteira.service';
import { FuncionarioService } from 'src/app/pages/cadastros/funcionario/funcionario.service';
import { UsuarioService } from 'src/app/services/usuario.service';

@Component({
  selector: 'app-funcionario',
  templateUrl: './funcionario.component.html',
  providers: [FuncionarioService, EmpreiteiraService, CategoriaService]
})
export class FuncionarioComponent implements OnInit, AfterContentInit {


  public cadastrados: any[] = [];
  public empreiteiras: any[] = [];
  public categorias: any[] = [];

  public form: FormGroup = null;

  public isEditing = false;
  public isProcessing = false;
  public isFiltered = false;
  public isLoading = false;

  public voids: string[] = [];
  public maxRowsVoids = 7;

  public autorizacoes: UsuarioAutorizacoes;

  constructor(
    private funcionarioService: FuncionarioService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private empreiteiraService: EmpreiteiraService,
    private categoriaService: CategoriaService,
    private usuarioService: UsuarioService
  ) { }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('funcionario');
  }

  ngOnInit() {
    this.getAll(); // carrega lista de já cadastrados
    this.getEmpreiteiras();
    this.getCategorias();
    this.resetForm(); // instancia o formulário utilizado (formGroup)
  }

  public getAll(): void {
    this.isLoading = true;
    this.funcionarioService.getAll().subscribe((response: any) => {
      this.cadastrados = response;
      this.setVoids();
      this.isLoading = false;
    });
  }

  public resetForm(): void {
    this.form = new FormGroup(
      {
        id: new FormControl(0),
        matricula: new FormControl(null, [Validators.required]),
        nome: new FormControl(null, [Validators.required]),
        categoriaId: new FormControl('', [Validators.required]),
        empreiteiraId: new FormControl('', [Validators.required]),
        ehEngenheiro: new FormControl(false),
        ehEncarregado: new FormControl(false),
      }
    );

    if (this.empreiteiras.length == 1) {
      this.form.get('empreiteiraId').setValue(this.empreiteiras[0].id);
    }

  }

  public getEmpreiteiras(): void {
    this.empreiteiraService.list().subscribe(
      (response) => {
        this.empreiteiras = response;
        if (this.empreiteiras.length == 1) {
          this.form.get('empreiteiraId').setValue(this.empreiteiras[0].id);
        }
      }
    );
  }

  public getCategorias(): void {
    this.categoriaService.list().subscribe(response => { this.categorias = response; });
  }


  public reset(): void {
    this.isEditing = false;
    this.isProcessing = false;
    this.isLoading = false;
    this.resetForm();
  }

  public getById(id: number): void {

    this.reset();
    this.isProcessing = true;

    this.funcionarioService.read(id).subscribe(

      (response: any) => {

        this.form.patchValue({
          id: response.id,
          matricula: response.matricula,
          nome: response.nome,
          categoriaId: response.categoriaId,
          empreiteiraId: response.empreiteiraId,
          ehEngenheiro: response.ehEngenheiro,
          ehEncarregado: response.ehEncarregado,
        })

        this.isEditing = true;
        this.isProcessing = false;
      },
      (error: any) => {
        this.showError(error);
      },
    );
  }

  public submit(): void {

    this.isProcessing = true;

    if (this.isEditing === false) {

      this.funcionarioService.isUniqueMatriculaFuncionario(this.form.get('matricula').value).subscribe(

        (isUniqueMatricula: boolean) => {

          if (isUniqueMatricula) {
            this.save();
          } else {
            this.form.get('matricula').setErrors({ isNotUniqueMatricula: true });
            this.isProcessing = false;
          }
        },
        (error: any) => { this.showError(error); }
      );
    } else {
      this.save();
    }
  }

  public save() {

    this.funcionarioService.create(this.form.value).subscribe(

      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.getAll();
      },
      (error: any) => {
        this.showError(error);
      }
    );

  }

  public setVoids(): void {
    this.voids = [];
    if (this.cadastrados.length < this.maxRowsVoids) {
      for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) { this.voids.push(''); }
    }
  }

  public showModalSm(modal: any) {
    this.modalService.open(modal, { windowClass: 'smModal', backdrop: 'static' });
  }

  public delete(id: number, c: any): void {

    this.isProcessing = true;
    c('Close click');

    this.funcionarioService.delete(id).subscribe(

      (response: any) => {

        if (response.success == true) {
          this.toastr.success(response.message);
        } else {
          this.toastr.warning(response.message);
        }

        this.reset();
        this.getAll();
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public showError(error: any) {


    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error('Ocorreu um erro no servidor');
    }

    this.isProcessing = false;
  }

  public clearValor() {
    this.form.get('valor').setValue(null);
  }

  search(parametro: string) {

    if (parametro === '') { return; }

    this.isLoading = true;

    this.funcionarioService.search(parametro).subscribe(response => {
      this.cadastrados = response;
      this.setVoids();
      this.isFiltered = true;
      this.isLoading = false;
    });
  }

  clearSearch() {
    (document.getElementById('parametro') as HTMLInputElement).value = '';
    this.getAll();
    this.reset();
    this.isFiltered = false;
  }

}
